import { useState } from "react";
import {
  TEModal,
  TEModalDialog,
  TEModalContent,
  TEModalBody,
  TEModalFooter,
  TEModalHeader,
} from "tw-elements-react";
import EdSwitch from "@/components/forms/EdSwitch";

interface CourseSettingsModalProps {
  show: boolean;
  onClose: () => void;
}

const CourseSettingsModal = ({ show, onClose }: CourseSettingsModalProps) => {
  // Stati per le impostazioni
  const [settings, setSettings] = useState({
    examAfterCourseDuration: true,
    studyTimeControl: true,
    knowledgeConfirmation: false,
    mandatoryViewing: true,
    presenceControlMinutes: 9,
    presenceVerification: false,
    responseTimeSeconds: 0,
    maxStudyHoursPerDay: 0,
    maxStudyHoursPerWeek: 0,
  });

  const handleSwitchChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setSettings(prev => ({ ...prev, [key]: event.target.checked }));
  };

  const handleNumberChange = (key: string, value: number) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    console.log('Salvando impostazioni:', settings);
    // Qui implementeresti la logica di salvataggio
    onClose();
  };

  return (
    <TEModal show={show} setShow={onClose} >
      <TEModalDialog size="lg" >
        <TEModalContent >
          <TEModalHeader>
            <h5 className="text-xl font-medium leading-normal text-neutral-800">
              Impostazioni
            </h5>
          </TEModalHeader>
          <TEModalBody >
            <div className="p-6" style={{maxHeight: '65vh', overflowY: 'auto'}}>
              <div className="space-y-4">
                {/* Row 1: Consentire l'esame solo dopo la durata del corso */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      Consentire l'esame solo dopo la durata del corso?
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                   
                    <EdSwitch
                      id="examAfterCourseDuration"
                      value={settings.examAfterCourseDuration}
                      onChange={handleSwitchChange('examAfterCourseDuration')}
                    />
                  </div>
                </div>

                {/* Row 2: Utilizzare il controllo sul tempo di studio */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      Utilizzare il controllo sul tempo di studio di un oggetto?
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-gray-600">
                      
                    </span>
                    <EdSwitch
                      id="studyTimeControl"
                      value={settings.studyTimeControl}
                      onChange={handleSwitchChange('studyTimeControl')}
                    />
                  </div>
                </div>

                {/* Row 3: Richiedere conferma di conoscenza */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      Richiedere conferma di conoscenza per la visione dell'oggetto successivo?
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-gray-600">
                      
                    </span>
                    <EdSwitch
                      id="knowledgeConfirmation"
                      value={settings.knowledgeConfirmation}
                      onChange={handleSwitchChange('knowledgeConfirmation')}
                    />
                  </div>
                </div>

                {/* Row 4: È obbligatoria la visione di tutti gli oggetti didattici */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      È obbligatoria la visione di tutti gli oggetti didattici?
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-gray-600">
                     
                    </span>
                    <EdSwitch
                      id="mandatoryViewing"
                      value={settings.mandatoryViewing}
                      onChange={handleSwitchChange('mandatoryViewing')}
                    />
                  </div>
                </div>

                {/* Row 5: Ogni quanti minuti mostrare la finestra di controllo */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      Ogni quanti minuti mostrare la finestra di controllo per la presenza?
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <input
                      type="number"
                      value={settings.presenceControlMinutes}
                      onChange={(e) => handleNumberChange('presenceControlMinutes', parseInt(e.target.value) || 0)}
                      className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                      min="0"
                    />
                  </div>
                </div>

                {/* Row 6: Verifica della presenza mediante una domanda */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      Verifica della presenza mediante una domanda sull'oggetto precedente?
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-gray-600">
                   
                    </span>
                    <EdSwitch
                      id="presenceVerification"
                      value={settings.presenceVerification}
                      onChange={handleSwitchChange('presenceVerification')}
                    />
                  </div>
                </div>

                {/* Row 7: In quanti secondi bisogna rispondere */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      In quanti secondi bisogna rispondere?
                    </span>
                    <i className="ri-question-line text-gray-400 text-sm"></i>
                  </div>
                  <div className="flex items-center gap-3">
                    <input
                      type="number"
                      value={settings.responseTimeSeconds}
                      onChange={(e) => handleNumberChange('responseTimeSeconds', parseInt(e.target.value) || 0)}
                      className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                      min="0"
                    />
                  </div>
                </div>

                {/* Row 8: Quante ore al giorno è possibile studiare */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      Quante ore al giorno è possibile studiare? (Tempo massimo in ore)
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <input
                      type="number"
                      value={settings.maxStudyHoursPerDay}
                      onChange={(e) => handleNumberChange('maxStudyHoursPerDay', parseInt(e.target.value) || 0)}
                      className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                      min="0"
                    />
                  </div>
                </div>

                {/* Row 9: Quante ore al settimana è possibile studiare */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-700">
                      Quante ore al settimana è possibile studiare? (Tempo massimo in ore)
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <input
                      type="number"
                      value={settings.maxStudyHoursPerWeek}
                      onChange={(e) => handleNumberChange('maxStudyHoursPerWeek', parseInt(e.target.value) || 0)}
                      className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                      min="0"
                    />
                  </div>
                </div>
              </div>
            </div>
          </TEModalBody>
          <TEModalFooter className="gap-4">
            <button
              className="px-6 py-2 text-sm font-medium text-white bg-[#B80F15] border border-transparent rounded-[4px] hover:bg-[#9A0C11] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#B80F15] transition-colors"
              onClick={handleSave}
            >
              Salva
            </button>
            <button
              className="px-6 py-2 text-sm font-medium text-[#285192] bg-[#E3EBF7] rounded-[4px] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
              onClick={onClose}
            >
              Chiudi
            </button>
          </TEModalFooter>
        </TEModalContent>
      </TEModalDialog>
    </TEModal>
  );
};

export default CourseSettingsModal;
